import { FC } from "react";
import { IUndesirableHoldingsProps } from "./types";
import { TextResources } from "@portal/assets/text/TextResources";
import UndesirableHolding from "./undiserableHolding";
import Typography from "@portal/components/atoms/v2/typography";

const UndesirableHoldings: FC<IUndesirableHoldingsProps> = ({ morningstarSecuritiesEsg }) => {
  return (
    <div>
      <Typography variant="BodySpan">{TextResources.FUND_DISTRIBUTION_UNDESIRABLE_HOLDINGS_TEXT_1}</Typography>
      <Typography variant="BoldSpan">{TextResources.FUND_DISTRIBUTION_UNDESIRABLE_HOLDINGS_TEXT_BOLD_PART}</Typography>
      <Typography variant="BodySpan">{TextResources.FUND_DISTRIBUTION_UNDESIRABLE_HOLDINGS_TEXT_2}</Typography>
      <ul className="px-2 mt-4 flex flex-col gap-3">
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_ALCOHOL_LABEL}
          value={morningstarSecuritiesEsg.alcohol}
          icon="alcoholIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_NUCLEAR_LABEL}
          value={morningstarSecuritiesEsg.nuclear}
          icon="nuclearIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_ANIMAL_TESTING_LABEL}
          value={morningstarSecuritiesEsg.animalTesting}
          icon="animalTestingIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_MILITARY_CONTRACTING_LABEL}
          value={morningstarSecuritiesEsg.militaryContracting}
          icon="militaryContractingIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_FOSSIL_FUELS_LABEL}
          value={morningstarSecuritiesEsg.thermalCoal}
          icon="fossilFuelsIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_GMO_LABEL}
          value={morningstarSecuritiesEsg.gmo}
          icon="gmoIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_WEAPONS_LABEL}
          value={morningstarSecuritiesEsg.smallArms}
          icon="weaponIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_PALM_OIL_LABEL}
          value={morningstarSecuritiesEsg.palmOil}
          icon="palmOilIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_PESTICIDES_LABEL}
          value={morningstarSecuritiesEsg.pesticides}
          icon="pesticidesIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_ADULT_ENTERTAINMENT_LABEL}
          value={morningstarSecuritiesEsg.adultEntertainment}
          icon="adultEntertainmentIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_GAMBLING_LABEL}
          value={morningstarSecuritiesEsg.gambling}
          icon="gamblingIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_TOBACCO_LABEL}
          value={morningstarSecuritiesEsg.tobacco}
          icon="tobaccoIcon"
        />
        <UndesirableHolding
          label={TextResources.FUND_DISTRIBUTION_UNDISERABLE_HOLDINGS_CONTROVERSIAL_WEAPONS_LABEL}
          value={morningstarSecuritiesEsg.controversialWeapons}
          icon="controversialWeaponsIcon"
        />
      </ul>
    </div>
  );
};

export default UndesirableHoldings;
